module.exports = __webpack_public_path__ + "img/how-nv24.79650d9c.png";